import React, { useEffect } from 'react';
import { NextPageWithLayout } from '@/pages/_app';
import { Layout } from '@/components/Common';
import { SEO_META } from '@/shared/seo';
import { SEO_META_PAGES } from '@/shared/types/seo';
import { logPageView } from '@/lib/service';
import { AUDIENCE_CAPTURE, AUDIENCE_CAPTURE_HEADER_CONTENT } from '@/shared/constants/platform-pages-constants';
import PlatformPage from '@/components/Platform';
import { WEBSITE_URL, STATIC_FILE_URL } from '@/shared/constants';
import PlatformHeader from '@/components/Platform/PlatformHeader';
import CustomHead from '@/components/Common/Layout/Head';
import './index.less';

const IdeationPage = ({}: NextPageWithLayout<any>) => {
  useEffect(() => {
    logPageView({
      pageUrl: window.location.href || '',
      routeName: window.location.pathname,
      pageTitle: `${AUDIENCE_CAPTURE.title} | Pietra`,
    });
  }, []);
  return (
    <>
      <PlatformHeader content={AUDIENCE_CAPTURE_HEADER_CONTENT} />
      <PlatformPage content={AUDIENCE_CAPTURE} utmSource="email_capture" />
    </>
  );
};

IdeationPage.getLayout = (page: React.ReactElement) => {
  return (
    <>
      <CustomHead
        title="Grow your e-mail list by 15x | Pietra Visitor ID"
        description="Convert website visitors into emails for marketing."
        url={`${WEBSITE_URL}/platform/email-capture`}
        image={`${STATIC_FILE_URL}/c73a19e302ad6c93de166cb9396fd254.png`}
      />
      <Layout
        structured={SEO_META[SEO_META_PAGES.IDEATION].jsonld({
          url: typeof window === 'object' ? window.location.href : '',
        })}
      >
        {page}
      </Layout>
    </>
  );
};

export default IdeationPage;
